import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import { PageHero } from "../components/Section";
import { useApp } from "../context/AppContext";
import { useReveal } from "../hooks/useReveal";
import { blogData } from "../data/blogData";
import { getBlog } from "../services/api";
import { IMAGES } from "../data/mock";
import { Calendar, ArrowRight } from "lucide-react";

const Blog = () => {
  const { t, lang } = useApp();
  const [posts, setPosts] = useState(blogData);
  useReveal([posts]);
  useEffect(() => {
    getBlog().then((d) => { if (Array.isArray(d) && d.length) setPosts(d); }).catch(() => {});
  }, []);
  const [featured, ...rest] = posts;
  const fmt = (d) => new Date(d).toLocaleDateString(lang === "de" ? "de-DE" : "en-US", { year: "numeric", month: "long", day: "numeric" });

  return (
    <div className="pt-20 bg-cream min-h-screen">
      <Seo title={t("blog.title")} description={t("blog.sub")} image={IMAGES.tasting2} path="/blog" lang={lang} />
      <PageHero title={t("blog.title")} subtitle={t("blog.sub")} image={IMAGES.tasting2} />
      <div className="max-w-7xl mx-auto px-6 py-16">
        <Link to={`/blog/${featured.slug}`} className="reveal group grid md:grid-cols-2 gap-8 bg-white rounded-3xl overflow-hidden border border-border hover:shadow-xl transition-all mb-14 block">
          <div className="h-72 md:h-auto overflow-hidden">
            <img src={featured.img || "/logo_moc.png"} alt={featured.title?.[lang] || "Blogbeitrag"} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
          </div>
          <div className="p-8 flex flex-col justify-center">
            <p className="flex items-center gap-1.5 text-xs text-gold-dark uppercase tracking-wider"><Calendar className="w-3.5 h-3.5" /> {fmt(featured.date)}</p>
            <h2 className="font-serif text-3xl text-ink mt-3 leading-tight">{featured.title[lang]}</h2>
            <p className="mt-4 text-ink/65 leading-relaxed">{featured.excerpt[lang]}</p>
            <p className="mt-4 text-sm text-ink/50">{t("blog.by")} {featured.author}</p>
            <span className="inline-flex items-center gap-1.5 mt-5 text-wine font-medium group/link">{t("common.readMore")} <ArrowRight className="w-4 h-4 group-hover/link:translate-x-1 transition-transform" /></span>
          </div>
        </Link>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-7">
          {rest.map((p) => (
            <Link to={`/blog/${p.slug}`} key={p.id} className="reveal group bg-white rounded-2xl overflow-hidden border border-border hover:shadow-xl hover:-translate-y-1 transition-all duration-300 block">
              <div className="h-44 overflow-hidden"><img src={p.img || "/logo_moc.png"} alt={p.title?.[lang] || "Blogbeitrag"} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" /></div>
              <div className="p-5">
                <p className="flex items-center gap-1.5 text-xs text-gold-dark uppercase tracking-wider"><Calendar className="w-3.5 h-3.5" /> {fmt(p.date)}</p>
                <h3 className="font-serif text-lg text-ink mt-2 leading-tight line-clamp-2">{p.title[lang]}</h3>
                <p className="mt-2 text-ink/60 text-sm leading-relaxed line-clamp-3">{p.excerpt[lang]}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Blog;
